<template>
  <transition name="fade" appear>
    <div class="modal-cont">
      <div class="overlay" @click="back"/>
      <div class="limit">
        <transition name="slide-fade-in" appear>
          <div class="modal">
            <slot></slot>
          </div>
        </transition>
      </div>
    </div>
  </transition>
</template>

<script>
import { actions } from '../../utils'

export default {
  props: ['closeTo'],
  methods: {
    back() {
      this.$store.dispatch('GO_BACK', { $router: this.$router, fallback: this.closeTo })
    },
    escListener({ keyCode, which }) {
      if ((keyCode || which) === 27) this.back()
    },
    ...actions(),
  },
  mounted() {
    this.ON({
      keydown: this.escListener,
    })
  },
  beforeDestroy() {
    this.OFF({
      keydown: this.escListener,
    })
  },
}
</script>

<style lang="scss">
@import '~style/variables';

.modal-cont {
  align-items: center;
  display: flex;
  height: 100%;
  height: 100vh;
  justify-content: center;
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  z-index: 5;
  &.lg .modal {
    max-height: 96%;
    max-width: 96%;
  }
  > .overlay {
    background: rgba($c-navy, 0.9);
    height: 100%;
    position: fixed;
    width: 100%;
  }
  > .limit {
    align-items: center;
    display: flex;
    height: 100%;
    justify-content: center;
    max-width: 1080px;
    max-height: 100%;
    right: 0;
    top: 0;
    width: 100%;
  }
}

.modal {
  // @include trans;
  background: #fff;
  border-radius: $r;
  box-shadow: 0 4px 26px rgba(0,0,0,.3);
  max-height: 90%;
  min-width: 320px;
  max-width: 640px;
  overflow-x: hidden;
  overflow-y: auto;
  pointer-events: auto;
  position: relative;
  width: 100%;
  z-index: 40;
  > .name {
    text-align: center;
    padding: 1.5rem 0;
  }
  > .text {
    font-weight: 600;
    padding: 2rem;
    position: relative;
    text-align: center;
    > .icon {
      font-size: $h1;
      left: 2rem;
      position: absolute;
      top: 1rem;
    }
    &.wicon {
      padding-left: 6rem;
    }
  }
  > .actions-row {
    padding: 1.5rem;
    .act {
      > .btn {}
    }
  }
  @media screen and (min-width: $res-md) {
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/globals/ModalCont.vue